const ADD_CONTENT_ITEM_LABEL = "Add Content Item";
const ADD_CONTENT_TAG_LABEL = "Add Content Tag";
const ADD_CONTENT_LABEL = "Add Content";
const CONTENT_CREATE_TITLE = "Create a Content";
const CONTENT_EDIT_TITLE = "Edit a Content & ";
const CONTENT_ORDER_TAB = "Content Orderable";
const CONTENT_ITEMS_TAB = "Content Items";
const CONTENT_ITEMS_ORDER_TAB = "Content Items Orderable";
const CONTENT_ITEM_CREATE_TITLE = "Create a Content Item";
const CONTENT_ITEM_EDIT_TITLE = "Edit a Content Item ";
const CONTENT_TAGS_TAB = "Content Tags";
const CONTENT_TAG_CREATE_TITLE = "Create a Content Tag";
const CONTENT_TAG_EDIT_TITLE = "Edit a Content Tag ";
const PUBLISH_LABEL = "Publish";
const UNPUBLISH_LABEL = "Unpublish";
const SAVE_CONTENT_ORDER_LABEL = "Save Content Order";
const SAVE_CONTENT_ITEM_ORDER_LABEL = "Save Content Item Order";
const SAVE_TOPIC_ORDER_LABEL = "Save Topic Order";
const TOPIC_CREATE_TITLE = "Create a Topic";
const TOPIC_EDIT_TITLE = "Edit a Topic & ";
const TOPIC_LIST_LABEL = "Topic List";
const TOPIC_ORDERABLE_LABEL = "Topics Orderable";
const SHOW_LABEL = "SHOW";

export {
  ADD_CONTENT_ITEM_LABEL,
  ADD_CONTENT_TAG_LABEL,
  ADD_CONTENT_LABEL,
  CONTENT_CREATE_TITLE,
  CONTENT_EDIT_TITLE,
  CONTENT_ITEM_CREATE_TITLE,
  CONTENT_ITEM_EDIT_TITLE,
  CONTENT_TAG_CREATE_TITLE,
  CONTENT_TAG_EDIT_TITLE,
  CONTENT_ITEMS_TAB,
  CONTENT_ITEMS_ORDER_TAB,
  CONTENT_ORDER_TAB,
  CONTENT_TAGS_TAB,
  PUBLISH_LABEL,
  UNPUBLISH_LABEL,
  SAVE_CONTENT_ORDER_LABEL,
  SAVE_CONTENT_ITEM_ORDER_LABEL,
  SAVE_TOPIC_ORDER_LABEL,
  TOPIC_CREATE_TITLE,
  TOPIC_EDIT_TITLE,
  TOPIC_LIST_LABEL,
  TOPIC_ORDERABLE_LABEL,
  SHOW_LABEL,
};
